module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_ship_f78113f92bea9e202c258a39d9e67ec5.png";